import {
  USER_GET_ALL,
  USER_GET_By_ID,
  USER_EDIT,
  USER_REMOVE,
  GET_CURRENT_USER_INFO,
} from "../actions/user-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const userReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case USER_GET_ALL.REQUEST:
    case USER_GET_By_ID.REQUEST:
    case USER_EDIT.REQUEST:
    case USER_REMOVE.REQUEST:
    case GET_CURRENT_USER_INFO.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USER_GET_ALL.SUCCESS:
    case USER_GET_By_ID.SUCCESS:
    case USER_EDIT.SUCCESS:
    case USER_REMOVE.SUCCESS:
    case GET_CURRENT_USER_INFO.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case USER_GET_ALL.FAILURE:
    case USER_GET_By_ID.FAILURE:
    case USER_EDIT.FAILURE:
    case USER_REMOVE.FAILURE:
    case GET_CURRENT_USER_INFO.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { userReducer };
